import { Controller } from "@hotwired/stimulus"

// Transport-level frame errors are local to this optional panel. API failures
// normally return a complete frame; this also covers a lost connection or proxy
// error returning no matching frame. Never touch the SMS controllers/forms.
export class ShopifyPanelController extends Controller {
    static targets = ["status"]

    failed(event) {
        event.preventDefault()
        if (this.hasStatusTarget) {
            this.statusTarget.hidden = false
            this.statusTarget.textContent = "Shopify information is unavailable. SMS is unaffected; please retry."
        }
    }
}
